var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39.4118,
    height: 20,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 39.4118,
    height: 20,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 39.4118,
    height: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3355 15.0518H35.239V15.3375H35.1746V15.0518H35.0781V14.9883H35.3677V15.0518H35.3355Z",
    fill: "#F9A11B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7376 15.3375H35.6733V15.0518L35.5768 15.3057H35.5124L35.4159 15.0518V15.3375H35.3516V14.9883H35.4481L35.5446 15.2422L35.6411 14.9883H35.7376V15.3375Z",
    fill: "#F9A11B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5469 9.99752C15.5469 13.1721 17.0589 16.0293 19.4073 17.8388C21.7557 15.9975 23.2676 13.1721 23.2676 9.99752C23.2676 6.82292 21.7557 3.96577 19.4073 2.15625C17.0589 3.96577 15.5469 6.82292 15.5469 9.99752Z",
    fill: "#F15F22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5462 10C15.5462 6.8254 17.0582 3.96825 19.4066 2.15873C17.6694 0.793651 15.5141 0 13.1335 0C7.53594 0 3 4.47619 3 10C3 15.5238 7.53594 20 13.1335 20C15.5141 20 17.6694 19.2064 19.4066 17.8413C17.0582 16 15.5462 13.1746 15.5462 10Z",
    fill: "#ED1C24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6637 0C23.2832 0 21.0956 0.793651 19.3906 2.15873C21.739 4 23.251 6.8254 23.251 10C23.251 13.1746 21.739 16.0317 19.3906 17.8413C21.1278 19.1746 23.2832 20 25.6637 20C31.2613 20 35.7972 15.5238 35.7972 10C35.7972 4.47619 31.2613 0 25.6637 0Z",
    fill: "#F9A11B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.7d26d131b123e7e45f8f8d77fbea69df.svg";
export { ForwardRef as ReactComponent };